import { EAdyenPaymentType, EPaymentMethods } from '@model';

export const getAdyenPaymentType = (providerType: EPaymentMethods | string): EAdyenPaymentType => {
  switch (providerType) {
    case EPaymentMethods.BLIK.toString():
      return EAdyenPaymentType.BLIK;
    case EPaymentMethods.APPLE_PAY.toString():
      return EAdyenPaymentType.APPLE_PAY;
    case EPaymentMethods.GOOGLE_PAY.toString():
      return EAdyenPaymentType.GOOGLE_PAY;
    case EPaymentMethods.ADYEN_IDEAL.toString():
      return EAdyenPaymentType.IDEAL;
    case EPaymentMethods.ADYEN_SWISH.toString():
      return EAdyenPaymentType.SWISH;
    case EPaymentMethods.ADYEN_TWINT.toString():
      return EAdyenPaymentType.TWINT;
    case EPaymentMethods.MB_WAY.toString():
      return EAdyenPaymentType.MBWAY;
    case EPaymentMethods.ADYEN_BAN_CONTACT.toString():
      return EAdyenPaymentType.BANCONTACT;
    case EPaymentMethods.ADYEN_BANCONTACT_MOBILE.toString():
      return EAdyenPaymentType.BANCONTACT_MOBILE;
    case EPaymentMethods.ADYEN_MOBILEPAY.toString():
      return EAdyenPaymentType.MOBILE_PAY;
    default:
      return EAdyenPaymentType.WEB;
  }
};
